//@ts-check

import { Product } from './product';

/**
 * Injects a stylesheet into the document as a <link> tag.
 * @param {string} url The URL of the stylesheet to inject.
 *
 * @example
 * injectStyle('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
 */
export const injectStyle = (url) => {
  const link = document.createElement('link');
  link.setAttribute('rel', 'stylesheet');
  link.setAttribute('href', url);
  document.head.appendChild(link);
};

/**
 * Add favicon to the document dynamically.
 *
 * @param {string} faviconUrl
 */
export const injectFavicon = (faviconUrl) => {
  /**
   * @type {HTMLAnchorElement | null}
   */
  const favicon = document.querySelector('link[rel="icon"]');
  if (!favicon) return;
  favicon.href = faviconUrl;
};

/**
 * Sets the document title.
 * @param {string} product
 * @param {string} portalName
 */
export const setTitle = (portalName, product) => {
  const titles = new Map([
    [Product.MediaPlanner, `${portalName} | Media Planner`],
    [Product.Analytics, `${portalName} | Analytics`],
    [Product.Admin, `${portalName} | Admin`],
    [Product.CreativeGallery, `${portalName} | Creative Gallery`],
  ]);
  document.title = titles.get(product) || `${portalName}`;
};

export const injectScript = (module = true, src, source = '') => {
  const script = document.createElement('script');
  script.type = module ? 'module' : '';
  script.noModule = !module;
  script.src = src;
  script.innerText = source;
  document.head.appendChild(script);
};
